/**
 * Retries a function call a specified number of times with optional delays.
 * @param {*} fn Function to call
 * @param {*} retries total retries
 * @param {*} delayMs Delay after each retry
 * @returns
 */
export async function retry(fn, retries = 1, delayMs = 0) {
  let lastError;

  for (let attempt = 1; attempt <= retries + 1; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      console.warn(`Attempt ${attempt} failed:`, error);

      if (attempt <= retries) {
        if (delayMs > 0) {
          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
        console.log(`Retrying... (${attempt}/${retries})`);
      }
    }
  }

  console.error(`All ${retries + 1} attempts failed.`);
  throw lastError;
}
